// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateUserNotificationSettingsV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["UserNotificationSettingsWasUpdated"]);
}

function unwrap_rawResponse_updateUserNotificationSettingsV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["UserNotificationSettingsWasUpdated"]);
}

let variablesConverter = {"updateUserNotificationSettingsV5Input":{},"__root":{"input":{"r":"updateUserNotificationSettingsV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateUserNotificationSettingsV5_UserNotificationSettingsWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationSettingsV5":{"u":"response_updateUserNotificationSettingsV5"}}};

let wrapResponseConverterMap = {
  response_updateUserNotificationSettingsV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateUserNotificationSettingsV5_UserNotificationSettingsWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationSettingsV5":{"u":"response_updateUserNotificationSettingsV5"}}};

let responseConverterMap = {
  response_updateUserNotificationSettingsV5: unwrap_response_updateUserNotificationSettingsV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let wrapRawResponseConverter = {"__root":{"updateUserNotificationSettingsV5":{"u":"rawResponse_updateUserNotificationSettingsV5"}}};

let wrapRawResponseConverterMap = {
  rawResponse_updateUserNotificationSettingsV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapRawResponse(v) {
  return RescriptRelay.convertObj(v, wrapRawResponseConverter, wrapRawResponseConverterMap, null);
}

let rawResponseConverter = {"__root":{"updateUserNotificationSettingsV5":{"u":"rawResponse_updateUserNotificationSettingsV5"}}};

let rawResponseConverterMap = {
  rawResponse_updateUserNotificationSettingsV5: unwrap_rawResponse_updateUserNotificationSettingsV5
};

function convertRawResponse(v) {
  return RescriptRelay.convertObj(v, rawResponseConverter, rawResponseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  wrapRawResponseConverter: wrapRawResponseConverter,
  wrapRawResponseConverterMap: wrapRawResponseConverterMap,
  convertWrapRawResponse: convertWrapRawResponse,
  rawResponseConverter: rawResponseConverter,
  rawResponseConverterMap: rawResponseConverterMap,
  convertRawResponse: convertRawResponse
};

function broadcastMessageNotificationPreferenceSettingV5_decode($$enum) {
  if ($$enum === "ALL_CATEGORIES" || $$enum === "NO_CATEGORIES") {
    return $$enum;
  }
}

let broadcastMessageNotificationPreferenceSettingV5_fromString = broadcastMessageNotificationPreferenceSettingV5_decode;

function entityNotificationPreferenceSettingV5_decode($$enum) {
  if ($$enum === "CHAPTER_DEFAULT" || $$enum === "MATCH_ONLY" || $$enum === "CUSTOM") {
    return $$enum;
  }
}

let entityNotificationPreferenceSettingV5_fromString = entityNotificationPreferenceSettingV5_decode;

let Utils = {
  broadcastMessageNotificationPreferenceSettingV5_decode: broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: broadcastMessageNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: entityNotificationPreferenceSettingV5_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationSettingsV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationSettingsBroadcastMessages_notificationSetting"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationSettingsWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationSettingsV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BroadcastMessageNotificationSettingV5",
                    "kind": "LinkedField",
                    "name": "broadcastMessages",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "setting",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationSettingsWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "18faf1c9c5efcd1c473012966a0f5038",
    "id": null,
    "metadata": {},
    "name": "NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation",
    "operationKind": "mutation",
    "text": "mutation NotificationSettingsBroadcastMessages_UpdateUserNotificationSettingsV5Mutation(\n  $input: UpdateUserNotificationSettingsV5Input!\n) {\n  updateUserNotificationSettingsV5(input: $input) {\n    __typename\n    ... on UserNotificationSettingsWasUpdated {\n      updatedUserNotificationSettings {\n        ...NotificationSettingsBroadcastMessages_notificationSetting\n        nodeId\n      }\n    }\n  }\n}\n\nfragment NotificationSettingsBroadcastMessages_notificationSetting on UserNotificationSettingsV5 {\n  nodeId\n  broadcastMessages {\n    setting\n  }\n}\n"
  }
};
})());

let wrap_response_updateUserNotificationSettingsV5 = RescriptRelay_Internal.wrapUnion;

let wrap_rawResponse_updateUserNotificationSettingsV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUserNotificationSettingsV5 = unwrap_response_updateUserNotificationSettingsV5;
exports.wrap_response_updateUserNotificationSettingsV5 = wrap_response_updateUserNotificationSettingsV5;
exports.unwrap_rawResponse_updateUserNotificationSettingsV5 = unwrap_rawResponse_updateUserNotificationSettingsV5;
exports.wrap_rawResponse_updateUserNotificationSettingsV5 = wrap_rawResponse_updateUserNotificationSettingsV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
